import { RestClient } from './RestClient'
import store from 'src/store'

export class DocumentsClient extends RestClient {
  /**
   * DocumentsClient constructor
   *
   * @constructor
   */
  constructor () {
    super()

    let currentTeam = store.getters.activeTeam
    this.baseUrl = `/teams/${currentTeam.id}/documents`
  }

  /**
   * Show the specified documents
   *
   * @param {(...number|number[])} id - Expenses to show
   *
   * @returns {AxiosPromise}
   */
  get (...id) {
    return this.call('get', `${this.baseUrl}/${this.parseAndJoin(id)}`)
  }

  /**
   * Download the file for the specified document
   *
   * @param {(...number|number[])} id - Expenses to show
   *
   * @returns {AxiosPromise}
   */
  file (id) {
    return this.call('get', `${this.baseUrl}/${id}`, null, {
      'Accept': 'application/pdf'
    }, {
      responseType: 'arraybuffer'
    })
  }

  /**
   * Download the preview for the specified document
   *
   * @param {(...number|number[])} id - Expenses to show
   *
   * @returns {AxiosPromise}
   */
  preview (id) {
    return this.call('get', `${this.baseUrl}/${id}/preview`, null, {
      'Accept': 'image/png'
    }, {
      responseType: 'arraybuffer'
    })
  }
}
